import React from "react";
import ReactDOM from "react-dom";
import App from "./pages";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { HelmetProvider } from "react-helmet-async";
import { CollapseDrawerProvider } from "contexts/CollapseDrawerContext";
import { RecoilExternalState } from "RecoilExternalState";
import { SettingsProvider } from "@fizen/ui-components";
// i18n
import "locales/i18n";
// scrollbar
import "simplebar/dist/simplebar.min.css";
import "simplebar/src/simplebar.css";
// styles
import "styles/tailwind.css";
import "styles/common.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
// apis
import "mocksdata";
import * as serviceWorker from "./serviceWorker";
import { ServiceWorkerProvider } from "contexts/ServiceWorkerContext";

// if (process.env.NODE_ENV === "production") {
//   console.log = () => {};
//   console.error = () => {};
//   console.debug = () => {};
// }

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <RecoilRoot>
          <ServiceWorkerProvider>
            <SettingsProvider>
              <CollapseDrawerProvider>
                <App />
              </CollapseDrawerProvider>
            </SettingsProvider>
          </ServiceWorkerProvider>
          <RecoilExternalState />
        </RecoilRoot>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

serviceWorker.register({
  onUpdate: async (registration) => {
    const waitingServiceWorker = registration.waiting;
    console.log("registration", registration);
    if (waitingServiceWorker) {
      console.log("waitingServiceWorker true");
      await registration.unregister();
      registration.installing.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          console.log("activated");
          alert("New version available. Refresh now");
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
}); // registerTest();
